module.exports = __webpack_public_path__ + "static/media/c2.661d1ce2.jpg";